module.exports = fox._r("fonts/iconfont.woff?ldnvmv", __webpack_public_path__ + "fonts/1JlKSi3.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/iconfont.woff?ldnvmv
// module id = 949
// module chunks = 4